module.exports = __webpack_public_path__ + "img/public/siteImages/noSearchResult.png?63615333";